import React from 'react';
import PropTypes from 'prop-types';
import StyledSwitch from './styled-components/StyledSwitch';
import StyledCheckbox from './styled-components/StyledCheckbox';
import StyledSlider from './styled-components/StyledSlider';

const Toggle = ({
  checked, disabledColor, enabledColor, onChange, onClick, rounded, theme,
}) => (
  <StyledSwitch enabledColor={enabledColor} theme={theme}>
    <StyledCheckbox
      checked={checked}
      className="checkbox"
      onChange={onChange}
      type="checkbox"
    />
    <StyledSlider
      className={rounded ? 'slider rounded' : 'slider'}
      disabledColor={disabledColor}
      onClick={onClick}
      theme={theme}
    />
  </StyledSwitch>
);

Toggle.propTypes = {
  disabledColor: PropTypes.string,
  enabledColor: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  rounded: PropTypes.bool,
  theme: PropTypes.object.isRequired,
};

Toggle.defaultProps = {
  disabledColor: '',
  enabledColor: '',
  rounded: false,
};

export default Toggle;
